// @ts-nocheck

export function setBrowserCookie(
  name: string,
  value: string,
  maxAgeSeconds = 60 * 60 * 24,
) {
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`;
}

export function getBrowserCookie(name: string): string | null {
  const prefix = `${name}=`;
  const part = document.cookie
    .split("; ")
    .find((item) => item.startsWith(prefix));
  return part ? decodeURIComponent(part.slice(prefix.length)) : null;
}

export function deleteBrowserCookie(name: string) {
  document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
}
